import React, { useState, useEffect } from "react";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Button, TextField } from "react-md";
import PropTypes from "prop-types";

import MCard from "components/Shared/MCard.tsx";
import { MSpinner } from "components/Shared";

const CaseIssueFields = (props) => {
  const [caseIssueOptions, setCaseIssueOptions] = useState(null);
  const [issueComments, setIssueComments] = useState([]);

  const { caseIssues, caseIssueComments, caseIssueTypes, updateIssues } = props;

  useEffect(() => {
    if (!caseIssueOptions) {
      setCaseIssueOptions(mapCaseIssues());
      setIssueComments(caseIssueComments);
    }
  }, []);

  const mapCaseIssues = () => {
    let issueGroups = [];
    caseIssueTypes.forEach(s => {
      if (!issueGroups[s.displayGroup]) {
        issueGroups[s.displayGroup] = [];
      }
      issueGroups[s.displayGroup].push({
        name: s.name,
        value: s.code,
        checked: caseIssues.some(p => p.code === s.code)
      });
    });
    return issueGroups;
  };

  const handleChange = (event, code, group) => {
    let issues = { ...caseIssueOptions };
    issues[group].filter(s => s.value === code)[0].checked = event.target.checked;
    setCaseIssueOptions(issues);
  };

  const commentsRequired = () => {
    for (const issue of Object.entries(caseIssueOptions)) {
      if (caseIssueOptions[issue[0]].some(s => s.checked)) {
        return true;
      }
    }
  };

  const getFields = () => {
    let issueGroups = [];
    for (let s in caseIssueOptions) {
      issueGroups.push(shapeIssueGroup(caseIssueOptions[s], s));
    }
    const caseIssueComments = (
      <div className={""}>
        <TextField
          id="floating-center-title"
          label="Case Issue Comments"
          value={issueComments}
          onChange={val => setIssueComments(val)}
          required={commentsRequired()}
          rows={3}
        />
      </div>);
    const caseIssueSave = (
      <div className={"save-control"}>
        <Button disabled={commentsRequired() && !issueComments.length} primary raised onClick={() => updateIssues(caseIssueOptions, issueComments)}>Save</Button>
      </div>
    );
    return (
      [{
        key: "issues", control: (
          <>
            {issueGroups}
            {caseIssueComments}
            {caseIssueSave}
          </>
        )
      }]
    );
  };

  const shapeIssueGroup = (issueGroup, groupName) => {
    return (
      <div key={groupName}>
        <div><b><u>{groupName}</u></b></div>
        <FormGroup row>
          {issueGroup.map(s => (
            <FormControlLabel
              key={s.value}
              control={
                <Checkbox
                  checked={s.checked}
                  onChange={event => handleChange(event, s.value, groupName)}
                  value={s.value}
                  color="primary"
                />
              }
              label={s.name}
            />
          ))}
        </FormGroup>
      </div>
    );
  };

  if (!caseIssueOptions) {
    return (<MSpinner />);
  }
  return (
    <MCard
      title="Case Issues"
      className="qa-case-issues"
      fields={getFields()}
    />
  );
};

CaseIssueFields.propTypes = {
  caseIssues: PropTypes.array,
  caseIssueComments: PropTypes.string,
  caseIssueTypes: PropTypes.array,
  updateIssues: PropTypes.func,
};

export default CaseIssueFields;